import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setBillingFunnelData, setBillingFunnelTotal, setLoadBillingFunnelData } from 'store/models/billingFunnel';

export default () => {
    return (dispatch, getState) => {
        dispatch(setLoadBillingFunnelData(true));
        const { from, to } = getState().billingFunnel;
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        return fetcher
            .get(`/api/v1/reports/billing_funnel?${queryStr}`)
            .then((data) => {
                dispatch([
                    setBillingFunnelData(data?.accountEfficiency || []),
                    setBillingFunnelTotal(data?.accountsTotalEfficiency || {}),
                    setLoadBillingFunnelData(false),
                ]);
            })
            .catch(() => {
                dispatch([setBillingFunnelData([]), setBillingFunnelTotal({}), setLoadBillingFunnelData(false)]);
            });
    };
};
